<div class="row">
    <div class="col-12 ">
        <alarm-route-recipients
          [tempRoute]="tempRoute"
          [fallbackRecipients]="true"
          [allStaff]="allStaff"
          [allReceiverTeams]="allReceiverTeams"
          [customerInformation]="customerInformation"
          [roleSymbols]="roleSymbols">
        </alarm-route-recipients>
    </div>
</div>
